// extracted by mini-css-extract-plugin
export default {"container":"FeaturesAmenities_container__etn2R","column":"FeaturesAmenities_column__L35pI","blockTitle":"FeaturesAmenities_blockTitle__rlXKz"};